import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import LandingScreen from "./LandingScreen";
import ResultScreen from "./ResultScreen";
import ChainReactionGameScreen from "./ChainReactionGameScreen";


const PageTransitionSequence = ({ sounds
}) => {

  const [screens, setScreens] = useState([
    { component: LandingScreen, name: 'landing', delay: 2000 },
    { component: ChainReactionGameScreen, name: 'game' },
    { component: ResultScreen, name: 'results' },
  ]);

  const [screenIndex, setScreenIndex] = useState(0);

  const linearSequenceAdvance = () => {
    let index = screenIndex + 1;
    
    if (screens.length <= index) {
      //restart sequence by skpping landing
      index = 1;
    }
    
    // console.log('linearSequenceAdvance', screenIndex, index);
    setScreenIndex(index);
  }

  useEffect(()=>{

  },[screenIndex]);

  const Screen = screens[screenIndex]['component'],
    delay = screens[screenIndex]['delay'] || 0;

  return <Screen 
    transitionOut={linearSequenceAdvance}
    sounds={sounds}
    delay={delay}
  />
  
};

PageTransitionSequence.propTypes = {
};

export default PageTransitionSequence;



// WEBPACK FOOTER //
// ./src/components/PageTransitionSequence.jsx